export const NON_REFUNDABLE_PROCESSING_FEE_NOTICE =
  "All payments include a payment processing fee. Because payment processors do not refund that fee to us after a charge is made, processing fees are non-refundable regardless of cancellation timing.";

export const NON_REFUNDABLE_PROCESSING_FEE_SHORT_NOTICE =
  "Payment processing fees are non-refundable, even when a cancellation qualifies for no cancellation fee.";

export const NON_REFUNDABLE_PROCESSING_FEE_REFUND_NOTE =
  "Any displayed refund excludes the non-refundable payment processing fee charged at the time of purchase.";

export function normalizeStorefrontPolicyText(policyText) {
  const text = String(policyText || "").trim();
  if (!text) return "";

  let normalized = text.replace(
    /a full refund will be issued/gi,
    "a refund of the order total minus non-refundable payment processing fees will be issued",
  );

  if (
    /full refund/gi.test(normalized) &&
    !/non-refundable payment processing fee|processing fees are non-refundable/gi.test(
      normalized,
    )
  ) {
    normalized = `${normalized}\n\n${NON_REFUNDABLE_PROCESSING_FEE_REFUND_NOTE}`;
  }

  return normalized;
}